import importerStore from '@shared/importer/importer-store';
import { GameService } from '@modules/game/game-service';
import gameImporterFields from '@modules/game/game-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
  GameService.import,
  gameImporterFields,
  i18n('entities.game.importer.fileName'),
  i18n('entities.game.importer.hint'),
);
